import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AgentPlatformAdminGate } from '../../../components/AgentPlatform/AgentPlatformAdminGate';

import { AgentPlatformFeatureGate } from '../../../components/AgentPlatform/AgentPlatformFeatureGate';

import { AgentPlatformPageHeader } from '../../../components/AgentPlatform/AgentPlatformPageHeader';

import { AgentPlatformPanel } from '../../../components/AgentPlatform/AgentPlatformPanel';

import { AgentPlatformShell } from '../../../components/AgentPlatform/AgentPlatformShell';

import { Button } from '../../../components/UI/Button';

import { useToast } from '../../../components/UI/ToastProvider';

import { agentPlatformService } from '../../../services/agentPlatformService';

import type {

  AgentPlatformAuditDto,

  AgentPlatformMonitoringSettings,

} from '../../../types/agentPlatform';

import { apTheme } from '../../../utils/agentPlatformTheme';



export const AgentGovernancePage: React.FC = () => {

  const { addToast } = useToast();

  const [settings, setSettings] = useState<AgentPlatformMonitoringSettings | null>(null);

  const [audit, setAudit] = useState<AgentPlatformAuditDto[]>([]);

  const [auditPage, setAuditPage] = useState(1);

  const [auditTotalPages, setAuditTotalPages] = useState(1);

  const [loading, setLoading] = useState(true);



  const load = async () => {

    setLoading(true);

    try {

      const [mon, aud] = await Promise.all([

        agentPlatformService.getMonitoringSettings(),

        agentPlatformService.getAudit({ page: auditPage, pageSize: 20 }),

      ]);

      setSettings(mon);

      setAudit(aud.data);

      setAuditTotalPages(aud.totalPages);

    } catch {

      addToast('Erro ao carregar governança.', 'error');

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    load();

  }, [auditPage]);



  const toggleTenantMonitoring = async (enabled: boolean) => {

    try {

      const updated = await agentPlatformService.updateTenantMonitoring({ enabled });

      setSettings(updated);

      addToast('Monitoria do tenant atualizada.', 'success');

    } catch {

      addToast('Sem permissão ou erro ao atualizar monitoria.', 'error');

    }

  };



  return (

    <AgentPlatformFeatureGate feature="platform">

      <AgentPlatformAdminGate>

        <AgentPlatformShell variant="governance">

          <AgentPlatformPageHeader

            title="Governança"

            subtitle="Políticas de monitoria, trilha de auditoria imutável e conformidade operacional."

            area="governance"
            actions={
              <Link to="/agent-platform/monitoring">
                <Button variant="secondary">Dashboard monitoria</Button>
              </Link>
            }
          />



          {loading && (

            <p className="text-slate-500 animate-pulse py-8 text-center">Carregando governança…</p>

          )}



          {settings && (

            <div className="grid lg:grid-cols-3 gap-6 mb-8">

              <div className={`${apTheme.governancePolicy} lg:col-span-1`}>

                <h2 className="text-base font-semibold text-slate-900 mb-1">Monitoria efetiva</h2>

                <p className="text-sm text-slate-600 mb-4">Estado consolidado global + tenant.</p>

                <p

                  className={`text-2xl font-bold mb-4 ${settings.effectiveEnabled ? 'text-emerald-600' : 'text-slate-400'}`}

                >

                  {settings.effectiveEnabled ? 'Ativa' : 'Inativa'}

                </p>

                <dl className="text-sm space-y-2 border-t border-sky-100 pt-4">

                  <div className="flex justify-between">

                    <dt className="text-slate-500">Global</dt>

                    <dd className="font-medium">{settings.globalEnabled ? 'On' : 'Off'}</dd>

                  </div>

                  <div className="flex justify-between">

                    <dt className="text-slate-500">Override tenant</dt>

                    <dd className="font-medium">

                      {settings.tenantOverride == null

                        ? '—'

                        : settings.tenantOverride

                          ? 'Forçada ON'

                          : 'Forçada OFF'}

                    </dd>

                  </div>

                </dl>

              </div>



              <AgentPlatformPanel

                title="Políticas do tenant"

                description="Ajuste o override local de coleta de métricas."

                className="lg:col-span-2"

              >

                <div className="flex flex-wrap gap-2">

                  <Button size="sm" onClick={() => toggleTenantMonitoring(true)}>

                    Ativar override

                  </Button>

                  <Button size="sm" variant="secondary" onClick={() => toggleTenantMonitoring(false)}>

                    Desativar override

                  </Button>

                  <Button

                    size="sm"

                    variant="ghost"

                    onClick={async () => {

                      try {

                        const updated = await agentPlatformService.updateTenantMonitoring({});

                        setSettings(updated);

                        addToast('Override removido.', 'success');

                      } catch {

                        addToast('Erro ao limpar override.', 'error');

                      }

                    }}

                  >

                    Limpar override

                  </Button>

                </div>

              </AgentPlatformPanel>

            </div>

          )}



          <AgentPlatformPanel title="Auditoria imutável" noPadding>

            <div className="overflow-x-auto">

              <table className="min-w-full divide-y divide-slate-100 text-sm">

                <thead>

                  <tr className={apTheme.tableHead}>

                    <th className="px-4 py-3 text-left">Quando</th>

                    <th className="px-4 py-3 text-left">Entidade</th>

                    <th className="px-4 py-3 text-left">Ação</th>

                    <th className="px-4 py-3 text-left">Usuário</th>

                  </tr>

                </thead>

                <tbody className="divide-y divide-slate-50">

                  {audit.map(row => (

                    <tr key={row.id} className="hover:bg-sky-50/40 transition-colors">

                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap text-xs">

                        {new Date(row.createdAt).toLocaleString('pt-BR')}

                      </td>

                      <td className="px-4 py-3">

                        <span className="font-mono text-xs text-red-700 bg-red-50 px-1.5 py-0.5 rounded">

                          {row.entityType}

                        </span>

                        {row.entityCode && (

                          <span className="block text-slate-500 text-xs mt-0.5">{row.entityCode}</span>

                        )}

                      </td>

                      <td className="px-4 py-3 text-slate-800">{row.actionDescription || row.action}</td>

                      <td className="px-4 py-3 text-slate-600">{row.userName || row.email}</td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

            <div className="flex justify-between items-center px-4 py-3 border-t border-slate-100 bg-slate-50/50">

              <Button

                variant="ghost"

                size="sm"

                disabled={auditPage <= 1}

                onClick={() => setAuditPage(p => p - 1)}

              >

                Anterior

              </Button>

              <span className="text-sm text-slate-500">

                {auditPage} / {auditTotalPages}

              </span>

              <Button

                variant="ghost"

                size="sm"

                disabled={auditPage >= auditTotalPages}

                onClick={() => setAuditPage(p => p + 1)}

              >

                Próxima

              </Button>

            </div>

          </AgentPlatformPanel>

        </AgentPlatformShell>

      </AgentPlatformAdminGate>

    </AgentPlatformFeatureGate>

  );

};


